import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">用户评价</h2>
          <p className="text-sm text-foreground-600 mt-2">来自91视频用户的真实反馈，感谢每一位观众的支持</p>
        </div>

        <div className="space-y-4 md:space-y-5">
          {commentsData.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-bold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-1 text-foreground-500 flex-shrink-0">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs font-medium">{item.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}